import React from 'react'
import { numberWithCommas } from '../../helpers/helpers'
import { FormattedData } from '../../types'
import { DirectionArrow } from '../shared/DirectionArrow'
import { DifferenceInCases, StyledTotalCases } from './JabTracker.styled'

export function TotalCases({
    data,
    type,
}: {
    data: FormattedData
    type: 'large' | 'small'
}) {
    const ausData = data['AUS']
    const caseDirection = ausData.cases.dailyDifference > 1 ? 'up' : 'down'
    const dailyActiveCases = ausData.cases.dailyActive
    const dailyDifference = ausData.cases.dailyDifference
    return (
        <StyledTotalCases type={type}>
            <span>TOTAL</span>
            <span className="totalCases--value">
                {numberWithCommas(dailyActiveCases)}
            </span>
            {dailyActiveCases !== 0 && (
                <DifferenceInCases direction={caseDirection}>
                    {DirectionArrow({
                        direction: caseDirection,
                    })}
                    {numberWithCommas(dailyDifference)}
                </DifferenceInCases>
            )}
        </StyledTotalCases>
    )
}
